import Controller from '../Controller'

const d3topojson = require('topojson')

// google javascript api needs a global initMap() callback
// so we create that function, pass it the loaded data
// and assign it to window.initMap
const initalizer = (arrayOfData) => {
  const initMap = () => {
    // ES6 array destructoring, yay
    const [geoJSONdata, data] = arrayOfData

    // construct the map-layer
    const map = new google.maps.Map(document.getElementById('map'), {
      zoom: 16,
      minZoom: 13,
      center: new google.maps.LatLng(46.949112, 7.447625),
      mapTypeId: 'roadmap',
      mapTypeControl: true,
      mapTypeControlOptions: {
        style: google.maps.MapTypeControlStyle.DROPDOWN_MENU,
        position: google.maps.ControlPosition.RIGHT_BOTTOM
      },
      disableDefaultUI: false
    })

    // parse topoJson as geojson
    const geoJSONObject = d3topojson.feature(
      geoJSONdata,
      geoJSONdata.objects['geojson-reduced']
    )

    // add features to map
    map.data.addGeoJson(geoJSONObject)

    // start the application
    Controller.init(map, data)
  }
  // setup callback for API
  window.initMap = initMap
}

export default initalizer



// WEBPACK FOOTER //
// ./src/mapSetup/initMap.js